export default `/* Ids Menu Header Component */
:host {
  display: flex;
  align-items: center;
}

.ids-menu-header {
  text-transform: uppercase;
  margin-block: var(--ids-menu-header-margin);
  padding-inline: var(--ids-menu-header-padding);
  font-weight: var(--ids-font-weight-bold);
  font-size: var(--ids-menu-header-font-size);
  color: var(--ids-menu-header-text-color);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  list-style: none;
  text-align: start;
  inline-size: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbWVudSIsInNvdXJjZXMiOlsiaWRzLW1lbnUtaGVhZGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgTWVudSBIZWFkZXIgQ29tcG9uZW50ICovXG46aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5pZHMtbWVudS1oZWFkZXIge1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xuICBtYXJnaW4tYmxvY2s6IHZhcigtLWlkcy1tZW51LWhlYWRlci1tYXJnaW4pO1xuICBwYWRkaW5nLWlubGluZTogdmFyKC0taWRzLW1lbnUtaGVhZGVyLXBhZGRpbmcpO1xuICBmb250LXdlaWdodDogdmFyKC0taWRzLWZvbnQtd2VpZ2h0LWJvbGQpO1xuICBmb250LXNpemU6IHZhcigtLWlkcy1tZW51LWhlYWRlci1mb250LXNpemUpO1xuICBjb2xvcjogdmFyKC0taWRzLW1lbnUtaGVhZGVyLXRleHQtY29sb3IpO1xuICBmb250LWZhbWlseTogdmFyKC0taWRzLWZvbnQtZmFtaWx5LWRlZmF1bHQpLCB2YXIoLS1pZHMtZm9udC1mYW1pbHktc3lzdGVtLXNhbnMpO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgaW5saW5lLXNpemU6IDEwMCU7XG59XG4iXX0= */`;
